<template>
  <!-- // 报表钻取明细 -->
  <div class="app-container" id="zbxcjList">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="日期类型" prop="rqlx">
          <el-select
            ref="dateType"
            v-model="queryParams.rqlx"
            placeholder="日期类型"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeRqlx"
          >
            <el-option
              v-for="item in dateTypelist"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计年份" prop="tjnf">
          <el-date-picker
            ref="tjnf"
            v-model="queryParams.tjnf"
            type="year"
            :clearable="false"
            value-format="yyyy"
            placeholder="选择年"
            size="small"
            style="width: 185px"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属季度" prop="jdyf" v-if="queryParams.rqlx == 2">
          <el-select
            ref="jd"
            v-model="queryParams.jdyf"
            placeholder="所属季度"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
          >
            <el-option
              v-for="item in jdList"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属月份" prop="jdyf" v-if="queryParams.rqlx == 3">
          <el-select
            ref="jd"
            v-model="queryParams.jdyf"
            placeholder="所属月份"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
          >
            <el-option
              v-for="item in yfList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="queryParams.bmbh"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeBm"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目状态" prop="xmzt">
          <el-select
            ref="xmzt"
            v-model="queryParams.xmzt"
            placeholder="项目状态"
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeHtzt"
          >
            <el-option
              v-for="item in htztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="queryParams.xmbh"
            placeholder="项目名称"
            filterable
            size="small"
            style="width: 285px"
            class="filter-item xmmc"
            clearable
            collapse-tags
            multiple
            @change="handleChangeXm"
            @visible-change="handleChangeXm"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="区域总监" prop="qyzj">
          <el-select
            ref="qyzj"
            v-model="queryParams.qyzj"
            placeholder="区域总监"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in qyzjList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            />
          </el-select>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            style="margin-right: 10px"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <div>
        <el-table
          v-loading="listLoading"
          :data="zbxcjList.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :max-height="height"
          id="zbxcjList"
        >
          <el-table-column
            label="操作"
            prop="xmmc"
            min-width="80px"
            :show-overflow-tooltip="true"
            align="center"
            v-if="canEdit"
            fixed
          >
            <template slot-scope="scope">
              <div class="table_count">
                <el-button size="mini" plain @click="handleToEdit(scope.row)"
                  >编辑</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="所属部门"
            prop="bmmc"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="项目名称"
            prop="xmmc"
            min-width="200px"
            :show-overflow-tooltip="true"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="区域总监"
            prop="areaDirector"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="咨询总监"
            prop="personAdvice"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="项目总监"
            prop="xmzj"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="风险结论"
            prop="xjjg"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <div class="xjjg">
                <div
                  :style="{
                    background:
                      scope.row.xjjg == '高'
                        ? '#D9001B'
                        : scope.row.xjjg == '中'
                        ? '#F59A23'
                        : '#70B603',
                    borderRadius: '5px',
                    color: ' #fff',
                  }"
                >
                  {{ scope.row.xjjg }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="频次类型"
            prop="jccs"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.jccs == 1
                    ? "首次"
                    : scope.row.jccs == 2
                    ? "二次"
                    : ""
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="整改任务项数"
            prop="zgrws"
            min-width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="table_count"
                @click="handleToZbDialogList(scope.row, 1)"
              >
                {{ scope.row.zgrws }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="已完成任务项数"
            prop="ywcrws"
            min-width="120px"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="table_count"
                @click="handleToZbDialogList(scope.row, 2)"
              >
                {{ scope.row.ywcrws }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="整改完成率"
            prop="zgwcl"
            min-width="100px"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="table_count"
                @click="handleToZbDialogList(scope.row, 2)"
              >
                {{ scope.row.zgwcl }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="巡检报告"
            prop="xjbg"
            min-width="100px"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="table_count"
                @click="handleToZbDialogList(scope.row, 3)"
              >
                {{ scope.row.xjbg }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="巡检时间"
            prop="xjrq"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="巡检组长"
            prop="xjzz"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="巡检成员"
            prop="xjcy"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="分公司人员"
            prop="fgscy"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <el-table-column
            label="拜访对象"
            prop="bfdx"
            min-width="200px"
            :show-overflow-tooltip="true"
            align="center"
          ></el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="zbxcjList.total > 0"
          :total="zbxcjList.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="editDialog"
      width="900px"
      :closeOnClickModal="false"
      v-if="editDialog"
      class="editDialog"
    >
      <div>
        <el-form
          ref="editForm"
          label-width="120px"
          :model="editForm"
          :hide-required-asterisk="false"
          :rules="editRules"
          v-loading.fullscreen.lock="fullscreenLoading"
        >
          <el-form-item label="项目名称：" prop="zbmc">
            <el-input
              show-word-limit
              placeholder=""
              v-model="editForm.xmmc"
              size="small"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="巡检时间：" prop="xjrq">
            <el-date-picker
              v-model="editForm.xjrq"
              style="width: 100%"
              type="date"
              placeholder="请选择"
              size="small"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="风险等级：" prop="xjjg">
            <el-select
              ref="status"
              v-model="editForm.xjjg"
              placeholder="风险等级"
              filterable
              size="small"
              style="width: 100%"
              class="filter-item"
            >
              <el-option
                v-for="item in fxdjList"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="巡检组长：" prop="xjzz">
            <div class="treeselect">
              <treeselect
                v-model="editForm.xjzz"
                placeholder="请选择员工"
                :options="deptUser"
                :disable-branch-nodes="true"
                :show-count="true"
                value-consists-of="LEAF_PRIORITY"
                no-results-text="未搜到任何结果"
                :clear-on-select="true"
                :normalizer="normalizer"
                style="width: 100%"
                size="small"
                :multiple="true"
              />
            </div>
          </el-form-item>
          <el-form-item label="巡检成员：" prop="xjcy">
            <div class="treeselect">
              <treeselect
                v-model="editForm.xjcy"
                placeholder="请选择员工"
                :options="deptUser"
                :disable-branch-nodes="true"
                :show-count="true"
                value-consists-of="LEAF_PRIORITY"
                no-results-text="未搜到任何结果"
                :clear-on-select="true"
                :normalizer="normalizer"
                style="width: 100%"
                size="small"
                :multiple="true"
              />
            </div>
          </el-form-item>
          <el-form-item label="分公司人员：" prop="fgscy">
            <div class="treeselect">
              <treeselect
                v-model="editForm.fgscy"
                placeholder="请选择员工"
                :options="deptUser"
                :disable-branch-nodes="true"
                :show-count="true"
                value-consists-of="LEAF_PRIORITY"
                no-results-text="未搜到任何结果"
                :clear-on-select="true"
                :normalizer="normalizer"
                style="width: 100%"
                size="small"
                :multiple="true"
              />
            </div>
          </el-form-item>
          <el-form-item label="拜访对象：" prop="bfdx" class="require-item">
            <div class="bfdx">
              <div>
                <span>董事长/理事长：</span>
                <el-input
                  show-word-limit
                  placeholder=""
                  v-model="editForm.bfdx.dsz"
                  style="width: 130px"
                  size="small"
                ></el-input>
              </div>
              <div>
                <span>行长/主任：</span>
                <el-input
                  show-word-limit
                  placeholder=""
                  v-model="editForm.bfdx.hz"
                  style="width: 130px"
                  size="small"
                ></el-input>
              </div>
              <div>
                <span>分管领导：</span>
                <el-input
                  show-word-limit
                  placeholder=""
                  v-model="editForm.bfdx.fgld"
                  size="small"
                  style="width: 130px"
                ></el-input>
              </div>
              <div>
                <span>牵头部门负责人：</span>
                <el-input
                  show-word-limit
                  placeholder=""
                  v-model="editForm.bfdx.qtbmfzr"
                  size="small"
                  style="width: 130px"
                ></el-input>
              </div>
              <div>
                <span>其他高管：</span>
                <el-input
                  show-word-limit
                  placeholder=""
                  v-model="editForm.bfdx.qtgg"
                  style="width: 130px"
                  size="small"
                ></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            label="巡检报告："
            prop="xjbg"
            v-if="editForm.file && editForm.file.length > 0"
          >
            <div
              v-for="(item, index) in editForm.file"
              :key="item.fileid"
              class="file-li"
            >
              <div>{{ item.filename }}</div>
              <div>
                <span class="del" @click="handleDelFile(item, index)"
                  >删除</span
                >
              </div>
            </div>
          </el-form-item>
          <el-form-item label="选择附件：" prop="fileIds" class="require-item">
            <el-row>
              <el-col :span="4">
                <el-upload
                  action="#"
                  class="upload-demo"
                  ref="upload"
                  :headers="headers"
                  :on-change="handleChange"
                  :on-exceed="handleExceed"
                  :file-list="fileList"
                  :auto-upload="false"
                  multiple
                  :limit="maxFileLen"
                  :disabled="maxFileLen < 1"
                >
                  <el-button
                    type="primary"
                    icon="el-icon-upload"
                    plain
                    :disabled="maxFileLen < 1"
                    >选择附件</el-button
                  >
                </el-upload>
              </el-col>
              <el-col :span="20" style="line-height: 40px">
                <div>
                  (单个文件不能超过10M，支持word、excel、pdf、zip、rar的格式，总数不能超过5个)
                </div>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialog = false" size="smalll">
            取消
          </el-button>
          <el-button type="primary" size="smalll" @click="handleEditResult()">
            确定
          </el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="整改计划查看"
      :visible.sync="zgjhViewDialog"
      width="800px"
      :closeOnClickModal="false"
      v-if="zgjhViewDialog"
      class="zgjhViewDialog"
    >
      <el-table
        :data="dialogList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="计划名称"
          align="center"
          prop="plan_name"
          :show-overflow-tooltip="true"
          min-width="120px"
        />
        <el-table-column
          label="任务名称"
          align="center"
          prop="task_name"
          :show-overflow-tooltip="true"
          min-width="120px"
        >
        </el-table-column>
        <el-table-column
          label="开始时间"
          align="center"
          prop="start_time"
          :show-overflow-tooltip="true"
          min-width="80px"
        >
        </el-table-column>
        <el-table-column
          label="结束时间"
          align="center"
          prop="end_time"
          :show-overflow-tooltip="true"
          min-width="80px"
        >
        </el-table-column>

        <el-table-column
          label="任务执行人"
          align="center"
          prop="executor"
          :show-overflow-tooltip="true"
          min-width="100px"
        >
        </el-table-column>
        <el-table-column
          label="任务状态"
          align="center"
          prop="status"
          :show-overflow-tooltip="true"
          min-width="80px"
        >
        </el-table-column>
        <el-table-column
          label="实际完成时间"
          align="center"
          prop="update_time"
          :show-overflow-tooltip="true"
          min-width="100px"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="巡检报告查看"
      :visible.sync="xjbgViewDialog"
      width="800px"
      :closeOnClickModal="false"
      v-if="xjbgViewDialog"
      class="xjbgViewDialog"
    >
      <el-table
        :data="dialogList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="报告名称"
          align="center"
          prop="filename"
          :show-overflow-tooltip="true"
          min-width="80px"
        />
        <el-table-column
          label="上传人"
          align="center"
          prop="xm"
          :show-overflow-tooltip="true"
          min-width="80px"
        >
        </el-table-column>
        <el-table-column
          label="上传时间"
          align="center"
          prop="uploadtime"
          :show-overflow-tooltip="true"
          min-width="80px"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          :show-overflow-tooltip="true"
          min-width="100px"
        >
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center">
              <div
                class="table_count"
                style="margin-right: 15px"
                @click="handleViewFile(scope.row)"
              >
                预览
              </div>
              <div class="table_count" @click="handleDownloadFile(scope.row)">
                下载
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
  
<script>
import { getDict, getXmxxList } from "@/api/common";
import { getBmxxList } from "@/api/itWeekly.js";
import { getAreaDirectorList } from "@/api/xmReview.js";
import Pagination from "@/components/Pagination";
import moment from "moment";
import { mapGetters } from "vuex";

import {
  exportInspectList,
  fileDelete,
  getZbDialogList,
  getZbInspecList,
  getZbInspectById,
  saveZbInspect,
  uploadFile,
  xmCheckAuthor,
} from "@/api/xmcheck.js";
import { addExportFileDate } from "@/utils/utils";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  // 列表分页
  name: "xsjmxList",
  components: { Pagination, Treeselect },
  computed: {
    ...mapGetters(["deptUser", "user"]),
    maxFileLen() {
      return 5 - this.editForm.file.length;
    },
  },
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      headers: {
        "x-token": localStorage.getItem("token"),
      },
      pickerOptions: {
        disabledDate: (time) => {
          let oldDate = new Date("2023-12-31T12:00:00.000Z");
          let oneYear = new Date(oldDate).getTime();
          return time.getTime() < oneYear;
        },
      },
      fileList: [],
      height: 800,
      listLoading: false,
      zbxcjList: {
        list: [],
        total: 1,
      },
      queryParams: {
        page: 1,
        pageSize: 10,
        bmbh: [],
        xmbh: [],
        xmmc: [],
        xmzt: [],
        qyzj: [],
        jdyf: "",
        rqlx: "1",
        tjnf: moment().format("YYYY"),
      },
      zgjhViewDialog: false,
      editDialog: false,
      xjbgViewDialog: false,
      editForm: {
        bfdx: {},
        file: [],
      },
      dateTypelist: [
        {
          label: "按年",
          value: "1",
        },
        {
          label: "按季",
          value: "2",
        },
        {
          label: "按月",
          value: "3",
        },
      ],
      jdList: [
        {
          label: "一季度",
          value: "1",
        },
        {
          label: "二季度",
          value: "2",
        },
        {
          label: "三季度",
          value: "3",
        },
        {
          label: "四季度",
          value: "4",
        },
      ],
      yfList: [
        {
          label: "一月",
          value: "01",
        },
        {
          label: "二月",
          value: "02",
        },
        {
          label: "三月",
          value: "03",
        },
        {
          label: "四月",
          value: "04",
        },
        {
          label: "五月",
          value: "05",
        },
        {
          label: "六月",
          value: "06",
        },

        {
          label: "七月",
          value: "07",
        },
        {
          label: "八月",
          value: "08",
        },
        {
          label: "九月",
          value: "09",
        },
        {
          label: "十月",
          value: "10",
        },
        {
          label: "十一月",
          value: "11",
        },
        {
          label: "十二月",
          value: "12",
        },
      ],
      fxdjList: ["高", "中", "低"],
      editRules: {
        xjrq: [
          { required: true, message: "巡检日期不能为空", trigger: "change" },
        ],
        xjjg: [
          { required: true, message: "风险等级不能为空", trigger: "change" },
        ],
        xjzz: [
          { required: true, message: "巡检组长不能为空", trigger: "change" },
        ],
        xjcy: [
          { required: true, message: "巡检成员不能为空", trigger: "change" },
        ],
        fgscy: [
          { required: true, message: "分公司成员不能为空", trigger: "change" },
        ],
      },
      bmList: [],
      htztList: [],
      xmList: [],
      qyzjList: [],
      dialogList: [],
      fullscreenLoading: false,
      canEdit: false,
      storageXmbh: "",
    };
  },
  mounted() {
    this.startWatching();
  },
  created() {
    if (!this.user?.xm) {
      this.$store.dispatch("common/fetchUserInfoAction");
    }
    if (!this.deptUser || this.deptUser?.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }

    if (sessionStorage.getItem("zbCheckDetailParams")) {
      let initParams = JSON.parse(
        sessionStorage.getItem("zbCheckDetailParams")
      );
      this.storageXmbh = initParams.xmbh;

      initParams.xmbh = [initParams.xmbh];
      initParams.tjnf = initParams.jcnf;
      this.queryParams = {
        ...this.queryParams,
        ...initParams,
      };
      this.queryParams.xmzt = [this.queryParams.xmzt + ""];
      this.queryParams.bmbh = [this.queryParams.bmbh];
    }
    getBmxxList("2", "1").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
        // this.queryParams.bmbh = [this.bmList[0].bmbh];
        this.getQyzjListFuc();
      }
    });
    getDict("xmgl_xmzt", "2").then((res) => {
      if (res.code == 0) {
        this.htztList = res.data;
        // if (localStorage.getItem("fzj_params")) {
        // } else {
        //   this.queryParams.xmzt = [res.data[0].dictValue];
        // }
        this.getXmxxListFun(true);
      }
    });
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      const { xmbh, tjnf, bmbh, xmzt, qyzj, rqlx, jdyf, page, pageSize } =
        this.queryParams;
      const data = {
        xmbh: xmbh.join(","),
        tjnf,
        rqlx,
        bmbh: bmbh.join(","),
        xmzt: xmzt.join(","),
        qyzj: qyzj.join(","),
        jdyf,
        page,
        pageSize,
      };

      getZbInspecList(data).then((response) => {
        const docH = document.documentElement.clientHeight;
        const mycontainerH =
          document.querySelector(".mycontainer").clientHeight;
        console.log(docH, mycontainerH);
        this.height = docH - mycontainerH - 80;
        this.listLoading = false;
        if (response.code === 0) {
          this.zbxcjList.list = response.data;
          this.zbxcjList.total = response.count;
          this.getPermision();
        } else {
          this.$message({
            showClose: true,
            message: response.msg,
            type: "error",
            duration: 2000,
            center: true,
          });
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    getQyzjListFuc() {
      getAreaDirectorList({ bmbh: this.queryParams.bmbh.join(",") }).then(
        (res) => {
          if (res.code == 0) {
            this.qyzjList = res.data;
          }
        }
      );
    },
    handleChangeBm(i) {
      this.queryParams.bmbh = i;
      this.queryParams.bmmc = i;
      this.getXmxxListFun();
      this.getQyzjListFuc();
    },
    getXmxxListFun(isFirst) {
      getXmxxList({
        xmlx: "DS",
        type: "2",
        range: "1",
        xmzt: this.queryParams.xmzt.join(","),
        bmbh: this.queryParams.bmbh.join(","),
      }).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          if (!isFirst) {
            this.queryParams.xmbh = [this.xmList[0].xmbh];
          }
          // this.queryParams.xmmc = this.xmList[0].xmjc;
          // this.getList();
        }
      });
    },
    handleToEdit(row) {
      this.editDialog = true;
      getZbInspectById({ id: row.id }).then((res) => {
        if (res.code == 0) {
          this.editForm = res.data;
          this.editForm.czsj = moment().format("YYYYMMDD");
          this.editForm.czr = this.user.xm;
          this.editForm.xjrq = moment(this.editForm.xjrq + "");

          this.editForm.xjzz = this.editForm.xjzz.split(",");
          this.editForm.xjcy = this.editForm.xjcy.split(",");
          this.editForm.fgscy = this.editForm.fgscy.split(",");
          console.log(this.editForm.bfdxMap);
          const bfdxObj = {
            dsz: "",
          };
          const bfdxArr = this.editForm.bfdx.split(",");
          for (let i in bfdxArr) {
            const index = bfdxArr[i].lastIndexOf("#");
            const xm = bfdxArr[i].substring(index + 1, bfdxArr[i].length);
            if (bfdxArr[i].charAt(0) == 1) {
              bfdxObj.dsz = xm;
            } else if (bfdxArr[i].charAt(0) == 2) {
              bfdxObj.hz = xm;
            } else if (bfdxArr[i].charAt(0) == 3) {
              bfdxObj.fgld = xm;
            } else if (bfdxArr[i].charAt(0) == 4) {
              bfdxObj.qtbmfzr = xm;
            } else if (bfdxArr[i].charAt(0) == 5) {
              bfdxObj.qtgg = xm;
            }
          }
          this.editForm.bfdx = bfdxObj;
          // this.maxFileLen = this.maxFileLen - this.editForm.file.length;
        } else {
          this.$message.error(res.smg);
        }
      });
    },
    handleEditResult() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          const { bfdx } = this.editForm;
          let bfdxStr = "";
          let hasBfdx = false;
          if (bfdx.dsz) {
            bfdxStr += "1#" + bfdx.dsz + ",";
            hasBfdx = true;
          }
          if (bfdx.hz) {
            bfdxStr += "2#" + bfdx.hz + ",";
            hasBfdx = true;
          }
          if (bfdx.fgld) {
            bfdxStr += "3#" + bfdx.fgld + ",";
            hasBfdx = true;
          }
          if (bfdx.qtbmfzr) {
            bfdxStr += "4#" + bfdx.qtbmfzr + ",";
            hasBfdx = true;
          }
          if (bfdx.qtgg) {
            bfdxStr += "5#" + bfdx.qtgg + ",";
            hasBfdx = true;
          }
          if (!hasBfdx) {
            this.$message.error("请输入拜访对象！");
            return;
          }

          let { uploadFiles } = this.$refs.upload;
          let fileLen = uploadFiles.length;
          let form = new FormData();
          uploadFiles.forEach((item, index) => {
            form.append("files", item.raw);
          });

          if (fileLen > 0) {
            //上传文件
            this.fullscreenLoading = true;
            form.append("id", this.editForm.id);
            return new Promise((resolve, reject) => {
              uploadFile(form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message.success("上传成功！");
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg,
                      showClose: true,
                    });
                    this.fullscreenLoading = false;
                  }
                  resolve(res);
                })
                .catch((err) => {
                  reject(err);
                });
            }).then((success) => {
              if (success.code == 0) {
                this.editForm.fileIds = success.data;
                this.saveForm(bfdxStr);
              }
            });
          } else if (fileLen == 0) {
            if (this.editForm.file.length > 0) {
              this.saveForm(bfdxStr);
            } else {
              this.$message.error("请上传巡检报告！");
              return;
            }
          } else {
            this.$message.error(res.msg);
            return false;
          }
        }
      });
    },
    saveForm(bfdxStr) {
      const { xmbh, xjrq, xjjg, xjzz, xjcy, fgscy, jcnf, jccs, id, fileIds } =
        this.editForm;

      const params = {
        xmbh: xmbh,
        xjrq: moment(xjrq).format("YYYYMMDD"),
        xjjg,
        xjzz: xjzz.join(","),
        xjcy: xjcy.join(","),
        fgscy: fgscy.join(","),
        bfdx: bfdxStr,
        jcnf,
        jccs,
        id,
        fileIds,
      };
      saveZbInspect(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.getList();
          this.editDialog = false;
        } else {
          this.$message.error(res.msg);
          this.editDialog = false;
        }
        this.fullscreenLoading = false;
      });
    },
    handleExport() {
      const { xmbh, tjnf, bmbh, xmzt, qyzj, rqlx, jdyf } = this.queryParams;
      const data = {
        xmbh: xmbh.join(","),
        tjnf,
        rqlx,
        bmbh: bmbh.join(","),
        xmzt: xmzt.join(","),
        qyzj: qyzj.join(","),
        jdyf,
      };
      exportInspectList(data).then((res) => {
        if (res.code === 0) {
          let fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          fileName = addExportFileDate(fileName);
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleChangeHtzt(i) {
      this.queryParams.xmzt = i;
      this.getXmxxListFun();
    },
    handleToZbDialogList(row, type) {
      const { id, jdyf, rqlx, tjnf } = row;
      const data = {
        type,
        id,
        jdyf,
        rqlx,
        tjnf,
      };
      if (type === 1) {
        this.zgjhViewDialog = true;
      } else if (type === 2) {
        this.zgjhViewDialog = true;
      } else {
        this.xjbgViewDialog = true;
      }
      getZbDialogList(data).then((res) => {
        if (res.code == 0) {
          this.dialogList = res.data;
        }
      });
    },
    handleViewFile(row) {
      const url = row.url;
      window.open(url);
    },
    handleDownloadFile(row) {
      const filePath = row.absolutepath;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    handleChange(file, fileList) {
      //验证上传文件的格式;
      const suffixReg = /(xls|xlsx|pdf|doc|docx|rar|zip)$/;
      const point = file.name.lastIndexOf(".");
      const suffix = file.name.substr(point + 1);
      const isFile = suffixReg.test(suffix);
      if (!isFile) {
        this.$message.error("请上传正确格式的文件 !");
        fileList.pop();
        return false;
      }
      // 验证文件大小
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        fileList.pop();
        return false;
      }
      // 验证上传文件重复;
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find((f) => f.name === file.name);
      if (existFile) {
        this.$message.error("当前文件已经存在!");
        fileList.pop();
        return false;
      }
    },
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 5 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleDelFile(row, index) {
      fileDelete({ fileId: row.fileid, path: row.absolutepath }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          document.querySelectorAll(".file-li")[index].remove();
          this.editForm.file.splice(index, 1);
          console.log(this.editForm.file);
          this.getList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getPermision() {
      xmCheckAuthor({ xmbh: "" }).then((res) => {
        if (res.code == 0) {
          if (res.data.manage == 1 || res.data.xzcheck == 1) {
            this.canEdit = true;
          } else {
            this.canEdit = false;
          }
        }
      });
    },
    handleChangeRqlx(i) {
      if (i == 1) {
        this.queryParams.jdyf = "";
      } else if (i == 2) {
        this.queryParams.jdyf = moment().quarter() + "";
      } else {
        this.queryParams.jdyf = "0" + (moment().month() + 1);
      }
    },
    startWatching() {
      setInterval(() => {
        const currentStorage =
          JSON.parse(sessionStorage.getItem("zbCheckDetailParams")) || {};
        if (this.storageXmbh !== currentStorage.xmbh) {
          location.reload();
        }
      }, 1000);
    },
    handleChangeXm() {
      setTimeout(() => {
        document.querySelector(
          "#zbxcjList .xmmc .el-select__tags"
        ).scrollLeft = 0;
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  padding-top: 0;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
.fxjl {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.fxjl span {
  width: 50px;
  background: rgb(217, 0, 27);
}
.table_count {
  color: #036eb8;
  cursor: pointer;
}
.bfdx {
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 33%;
    display: flex;
    > span {
      width: 115px;
      text-align: right;
    }
  }
}
.treeselect {
  line-height: 21px;
}
.file-li {
  display: flex;
  div:nth-of-type(1) {
    margin-right: 30px;
  }
  div:nth-of-type(2) {
    color: #ff0000;
    cursor: pointer;
  }
}
</style>

